import esLocales from './resources/es';
import enLocales from './resources/en';

const locales = {
	es: esLocales,
	en: enLocales,
};

export default locales;